import React from "react";
import { IconButton } from "../icon-button";

import "./command-history.css";

export const CommandHistory = ({
	isUndoDisabled,
	onUndoClick,
	isRedoDisabled,
	onRedoClick,
}: {
	isUndoDisabled: boolean;
	onUndoClick(): void;
	isRedoDisabled: boolean;
	onRedoClick(): void;
}) => (
	<span className="command-history">
		<IconButton
			className="command-history__undo"
			iconName="undo"
			onClick={onUndoClick}
			disabled={isUndoDisabled}
		/>
		<IconButton
			className="command-history__redo"
			iconName="redo"
			onClick={onRedoClick}
			disabled={isRedoDisabled}
		/>
	</span>
);
CommandHistory.displayName = "CommandHistory";
